<template>
  <v-select
    color="white"
    class="white--text text-caption"
    height="22px"
    :style="[currentColor]"
    solo
    v-model="computedValue"
    dense
    :items="permissionItems"
    hide-details
    :menu-props="{
      closeOnContentClick: true,
      offsetY: true,
    }"
    :placeholder="computedValue === null ? $i18n.t('dialog.body.mixed') : ''"
    @change="$emit('change', $event)"
    @click.native.stop
  >
    <template #item="{item,on,attrs}">
      <v-list-item v-on="on" v-bind="attrs">
        <v-list-item-content>
          <v-list-item-title class="text-left">
            <v-chip x-small :color="permissionColors[item.value]" class="white--text text-caption">
              {{ item.text }}
            </v-chip>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  name: 'PermissionsSelect',
  props: {
    value: {
      type: Number,
    },
    permissionLevels: {
      type: String,
      default: 'three',
      validator: value => {
        return ['two', 'three'].includes(value);
      },
    },
  },
  data: vm => ({
    colors: {
      two: {
        1: 'success',
        0: 'error',
      },
      three: {
        2: 'success',
        1: 'edit',
        0: 'error',
      },
    },
    items: {
      two: [
        {
          text: vm.$i18n.t('dialog.body.access'),
          value: 1,
        },
        {
          text: vm.$i18n.t('dialog.body.noAccess'),
          value: 0,
        },
      ],
      three: [
        {
          text: vm.$i18n.t('dialog.body.edit'),
          value: 2,
        },
        {
          text: vm.$i18n.t('dialog.body.preview'),
          value: 1,
        },
        {
          text: vm.$i18n.t('dialog.body.noAccess'),
          value: 0,
        },
      ],
    },
  }),
  computed: {
    currentGroupPermissions: get('users/currentGroupPermissions'),
    currentColor() {
      return {
        '--current-color': this.$_colors[this.permissionColors[this.value]] || '#7c7c7c',
      };
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    permissionItems() {
      return this.items[this.permissionLevels];
    },
    permissionColors() {
      return this.colors[this.permissionLevels];
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-input__slot {
    min-height: 22px !important;
    background-color: var(--current-color) !important;
  }
  .v-input__control {
    min-height: unset !important;
  }
  .v-select__selection--comma {
    color: unset !important;
  }
  .v-select__selection {
    color: white !important;
  }
  .v-select__selections input::placeholder {
    color: white;
    opacity: 1;
  }
  .v-input__icon i {
    color: white;
    font-size: 20px;
  }
}
</style>
